export type ReportSummaryParsed = {
  range: { startDate?: string; endDate?: string };
  totals: Record<string, number>;
  rowCount: number;
};

export function parseReportSummaryPayload(data: unknown): ReportSummaryParsed {
  if (!data || typeof data !== 'object') {
    return { range: {}, totals: {}, rowCount: 0 };
  }
  const raw = data as Record<string, unknown>;
  return {
    range: (raw.range as { startDate?: string; endDate?: string }) || {},
    totals: (raw.totals as Record<string, number>) || {},
    rowCount: typeof raw.rowCount === 'number' ? raw.rowCount : 0,
  };
}
